import React from 'react';
import { FaTrash } from 'react-icons/fa';

const iconClass = "w-5 h-5";

const ToolbarNode = ({ data, duplicateNode, removeNode, setEditingNodeId, selectedNodeId, setConfigPanelOpen, isDarkMode }) => {

  if(data?.data?.id === 'start-step'){
    //retorna null para não exibir o toolbar
    return null;
  }

  return (
    <div className={`${isDarkMode ? 'bg-gray-700' : 'bg-blue-500'} rounded-lg shadow-md flex flex-col items-center justify-center`} style={{
      position: 'absolute',
      top: -50,
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 1000,
    }}>
      <div className="flex flex-row   w-full justify-center items-center" style={{
        margin: '0',
        padding: '0',
         
      }}>
        <button
          className={`flex flex-col items-center justify-center p-2 rounded transition text-white ${isDarkMode ? 'hover:bg-gray-600' : 'hover:bg-blue-600'}`}
          title="Editar"
          onClick={() => {
            setEditingNodeId(null);
            setConfigPanelOpen(false);
            setEditingNodeId(data.id);
          }}
        >
          {/* Editar icon */}
          <svg className={iconClass} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path d="M15.232 5.232l3.536 3.536M9 13l6.586-6.586a2 2 0 112.828 2.828L11.828 15.828a2 2 0 01-1.414.586H7v-3a2 2 0 01.586-1.414z" />
          </svg>
        </button>
        <button
          className={`flex flex-col items-center justify-center p-2 rounded transition text-white ${isDarkMode ? 'hover:bg-gray-600' : 'hover:bg-blue-600'}`}
          title="Duplicar"
          onClick={() => {
             
            const newId = duplicateNode(data.id); 
             
          }}
        >
          {/* Duplicar icon */}
          <svg className={iconClass} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <rect x="9" y="9" width="13" height="13" rx="2" />
            <rect x="3" y="3" width="13" height="13" rx="2" />
          </svg>
        </button>
        <button
            className={`flex flex-col items-center justify-center p-2 rounded transition text-white ${isDarkMode ? 'hover:bg-gray-600' : 'hover:bg-blue-600'}`}
          title="Duplicar sequência" style={{display: 'none'}}
        >
          {/* Duplicar sequencia icon */}
          <svg className={iconClass} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <rect x="3" y="3" width="7" height="7" rx="2" />
            <rect x="14" y="14" width="7" height="7" rx="2" />
            <path d="M10 7v2a2 2 002 2h2" />
          </svg>
        </button>
        <button
          className={`flex flex-col items-center justify-center p-2 rounded transition text-white ${isDarkMode ? 'hover:bg-red-700' : 'hover:bg-red-600'}`}
          title="Remover"
          onClick={() => removeNode(data.id)}
        >
          {/* Remover icon */}
           <FaTrash className={iconClass} />
        </button>
      </div>
    </div>
  );
};

export default ToolbarNode;
